import React from 'react'

import Reflux from 'reflux-react-16'

import LoginStore from '../../stores/LoginStore.js'
import LoginActions from '../../actions/LoginActions.js'

import {Alert, Button, Card, Colors, H3, P} from '../../components/UI/index.js'
import {formSpacing, FormStack, Input} from '../../components/UI/forms/index.js'
import LoadingPage from './LoadingPage.js'

export default class ForgotPassword extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {email: '', message: '', loading: false}
        this.store = LoginStore
    }

    componentDidMount() {
        document.title = 'Wachtwoord vergeten'
    }

    onSubmit(event) {
        event.preventDefault()
        const {email} = this.state
        this.setState({message: '', loading: true})

        const domain = window?.location.hostname

        LoginActions.sendResetPasswordMail(email, !['localhost', 'dev.veloyd.nl', 'test.veloyd.nl', 'app.veloyd.nl'].includes(domain) ? domain : null, () => {
            this.setState({message: 'Als jouw emailadres bij ons bekend is, is er een email gestuurd om je wachtwoord te wijzigen.', loading: false})
        })
    }

    onClickLogin() {
        window.location = '/login'
    }

    render() {
        const {email, message, loading, brandingLoading, branding} = this.state

        if (brandingLoading) {
            return <LoadingPage />
        }

        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflowY: 'auto', background: Colors.backgroundNeutral}}>
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                    <form style={{width: '100%', maxWidth: 474, padding: '0 12px'}} onSubmit={this.onSubmit.bind(this)}>
                        <Card shadow='true' style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 450, padding: 24, marginTop: 120, marginLeft: 'auto', marginRight: 'auto'}}>

                            <img style={{maxHeight: 128, maxWidth: 256, marginBottom: 48, objectFit: 'contain'}} src={branding?.mainLogo || '/images/VELOYDLOGO.png'} />

                            <H3 style={{marginBottom: 36}}>Wachtwoord vergeten</H3>
                            <P style={{maxWidth: 400, marginBottom: 24}}>Vul hieronder het emailadres van je account in.</P>

                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                <Input
                                    style={{width: '100%'}}
                                    type='email'
                                    label='Emailadres'
                                    value={email}
                                    onChange={(event) => this.setState({email: event.target.value.toLowerCase()})}
                                />
                            </FormStack>

                            {message && <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>}

                            <Button
                                type='submit'
                                style={{width: '100%', marginTop: 12}}
                                color={branding?.color || Colors.brandColor}
                                loading={loading}
                            >
                                Bevestigen
                            </Button>

                            <Button
                                style={{margin: 'auto', marginTop: 72}}
                                variant='text'
                                onClick={this.onClickLogin.bind(this)}
                            >
                                Inloggen
                            </Button>
                        </Card>
                    </form>
                </div>
            </div>
        )
    }
}
